<template>
  <div class="overviewLeft-main">
    <div class="title">
      <img src="/images/logo.png" />
      多能物联数据中心
      <span>MEIC Data Center</span>
    </div>
    <div class="main-content">
      <div class="card">
        <div class="title">近15日光伏发电量</div>
        <div class="content">
          <lineBarChart ref="barOpt" id="barOpt" :simpleOptions="barOpt" />
        </div>
      </div>
      <div class="card">
        <div class="title">近15日储能充放电量</div>
        <div class="content">
          <lineBarChart ref="lineOpt1" id="lineOpt1" :simpleOptions="lineOpt1" />
        </div>
      </div>
      <div class="card">
        <div class="title">近15日负荷用电量</div>
        <div class="content">
          <lineBarChart ref="lineOpt2" id="lineOpt2" :simpleOptions="lineOpt2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import login from "@/mixins/login";
import park from "@/mixins/park";
import LineBarChart from "@/components/chart/lineBarChart.vue";
import {gen30DayData, storage30DayData, load30DayData} from "@/api/overview";

export default {
  name: "overviewLeft",
  mixins: [login, park],
  components: {
    LineBarChart,
  },
  data() {
    return {
      commonLineOpt: {
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#747E94FF",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          nameTextStyle: {
            color: "#BFC8DB",
          },
          axisLabel: {
            color: "#BFC8DB",
          },
          splitLine: {
            lineStyle: {
              color: "#747E94",
            },
          },
        },
        series: {
          type: "line",
          smooth: true,
          showSymbol: false,
        },
      },
      genData: [],
      storageData: {
        in: [],
        out: [],
      },
      loadData: [],
    };
  },
  computed: {
    barOpt() {
      return {
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          textStyle: {
            color: "#fff",
          },
          data: ["电量"],
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#747E94FF",
            },
          },
          axisLabel: {
            color: "#fff",
          },
          data: this.genData.map((x) => x.date),
        },
        yAxis: {
          type: "value",
          name: "电量(kWh)",
          axisLine: {
            show: false,
          },
          nameTextStyle: {
            color: "#BFC8DB",
          },
          axisLabel: {
            color: "#BFC8DB",
          },
          splitLine: {
            lineStyle: {
              color: "#747E94",
            },
          },
        },
        series: [
          {
            name: "电量",
            data: this.genData.map((x) => x.value),
            type: "bar",
            smooth: true,
            showSymbol: false,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00B6F4", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
    },
    lineOpt1() {
      return {
        legend: {
          ...this.commonLineOpt.legend,
          data: ["充电", "放电"],
        },
        xAxis: {
          ...this.commonLineOpt.xAxis,
          data: this.storageData.in.map((x) => x.date),
        },
        yAxis: {
          ...this.commonLineOpt.yAxis,
          name: "电量(kWh)",
        },
        series: [
          {
            ...this.commonLineOpt.series,
            name: "充电",
            data: this.storageData.in.map((x) => x.value),
            itemStyle: {
              color: "#00EEFF",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00EEFF", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          {
            ...this.commonLineOpt.series,
            name: "放电",
            data: this.storageData.out.map((x) => x.value),
            itemStyle: {
              color: "#00FF8C",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00FF8C", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
    },
    lineOpt2() {
      return {
        legend: {
          ...this.commonLineOpt.legend,
          data: ["电量"],
        },
        xAxis: {
          ...this.commonLineOpt.xAxis,
          data: this.loadData.map((x) => x.date),
        },
        yAxis: {
          ...this.commonLineOpt.yAxis,
          name: "电量(kWh)",
        },
        series: [
          {
            ...this.commonLineOpt.series,
            name: "电量",
            data: this.loadData.map((x) => x.value),
            itemStyle: {
              color: "#00EEFF",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00EEFF", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
    },
  },
  mounted() {
    this.setFontSize();
    window.addEventListener("resize", this.setFontSize);
  },
  methods: {
    setFontSize() {
      const screenWidth =
        document.querySelector(".overviewLeft-main") && document.querySelector(".overviewLeft-main").offsetWidth;
      // 假设您希望在容器宽度为1680px时，html根元素的字体大小为16px
      const fontSize = (14 * screenWidth) / 1000;
      document.documentElement.style.fontSize = fontSize + "px";
    },
    getData() {
      this.getParkList("left");
    },
    // 光伏
    getGen30DayData() {
      gen30DayData({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.genData = res.data.data.slice(res.data.data.length - 15);
        this.$nextTick(() => {
          this.$refs.barOpt.updateChart();
        });
      });
    },
    // 储能
    getStorage30DayData() {
      storage30DayData({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.storageData = {
          in: res.data.data.in.slice(res.data.data.in.length - 15),
          out: res.data.data.out.slice(res.data.data.out.length - 15),
        };
        this.$nextTick(() => {
          this.$refs.lineOpt1.updateChart();
        });
      });
    },
    // 负荷
    getLoad30DayData() {
      load30DayData({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.loadData = res.data.data.slice(-15);
        this.$nextTick(() => {
          this.$refs.lineOpt2.updateChart();
        });
      });
    },
  },
};
</script>

<style lang="scss">
.overviewLeft-main {
  width: 1000px;
  padding: 0 !important;
  box-sizing: border-box !important;
  background: url("../assets/images/left背景.png");
  background-size: 100% 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  & > .title {
    display: flex;
    align-items: center;
    font-size: 2rem;
    padding: 2.857rem 0 0 2.857rem;
    font-family: Microsoft YaHei;
    font-weight: 700;

    img {
      width: 10.285rem;
      height: 1.857rem;
      margin-right: 1.142rem;
    }

    span {
      font-style: italic;
      color: #009bdb;
      font-family: Microsoft YaHei;
      opacity: 0.8;
    }
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px 40px;
    .card {
      display: flex;
      flex-direction: column;
      flex: 1;
      & + .card {
        margin-top: 15px;
      }
      & > .title {
        background: url("../assets/images/fhTitleL.png");
        background-size: 100% 100%;
        height: 36px;
        line-height: 36px;
        font-size: 20px;
        padding-left: 40px;
      }
      & > .content {
        flex: 1;
      }
    }
  }
}
</style>
